import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '..';
import { Fornitor_table_interface } from '@bludata/common-interfaces';
import { Filiale } from '../../interface/Filiale';
import { fetchListaFiliali } from '../../data_fetching/data_fetch_functions/fetchListaFiliali';
import { fetchListaFornitoriAttivi } from '../../data_fetching/data_fetch_functions/fetchListaFornitoriAttivi';

export interface OrdiniSliceState {
  listaFiliali: Filiale[];
  loading: boolean;
  loadingError: boolean;
  listaFornitori: Fornitor_table_interface[];
  page: number;
}

const initialState: OrdiniSliceState = {
  listaFiliali: [],
  loading: false,
  loadingError: false,
  listaFornitori: [],
  page: 1,
};

export const OrdiniSlice = createSlice({
  name: 'ordini',
  initialState,
  reducers: {
    setListaFilialiArchivi(
      state: OrdiniSliceState,
      action: PayloadAction<Filiale[]>,
    ) {
      state.listaFiliali = action.payload;
    },
    setListaFornitori(
      state: OrdiniSliceState,
      action: PayloadAction<Fornitor_table_interface[]>,
    ) {
      state.listaFornitori = action.payload;
    },
    setLoading(state: OrdiniSliceState, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setLoadingError(state: OrdiniSliceState, action: PayloadAction<boolean>) {
      state.loadingError = action.payload;
    },
    setPage(state: OrdiniSliceState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setListaFilialiArchivi,
  setLoading,
  setLoadingError,
  setListaFornitori,
  setPage,
} = OrdiniSlice.actions;

export const fetchFilterData = () => {
  return (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setLoadingError(false));

    Promise.all([fetchListaFiliali(), fetchListaFornitoriAttivi()])
      .then((responseList) => {
        const [listaFiliali, listaFornitori] = responseList;
        dispatch(setListaFilialiArchivi(listaFiliali));
        dispatch(setListaFornitori(listaFornitori));
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
        dispatch(setLoadingError(true));
      });
  };
};

export default OrdiniSlice.reducer;
